import { Component, h, Prop } from '@stencil/core';
import { AmountControlValues } from '../../../../types/types';

@Component({
  tag: 'rentware-amount-control-search-template',
  styleUrl: 'style-search.sass',
  shadow: false,
})
export class RentwareAmountControlSearchTemplate {
  @Prop() controlValues: AmountControlValues;
  @Prop() onIncreaseValue: (number) => void;
  @Prop() onInputChange: (event) => void;
  @Prop() onValidateKey: (event) => void;
  @Prop() label: string;

  get minusButtonEnabled() {
    return this.controlValues.itemAmount > 1;
  }

  get minusButtonStyle(): string {
    let minusButtonStyle = 'RACSButton';

    if (this.minusButtonEnabled) {
      minusButtonStyle += ' RACSButtonWaved';
    } else {
      minusButtonStyle += ' RACSButtonDisabled';
    }

    return minusButtonStyle;
  }

  get minusButtonCallback() {
    if (!this.minusButtonEnabled || this.controlValues.disabled) {
      return () => {};
    }

    return () => this.onIncreaseValue(-1);
  }

  get plusButtonCallback() {
    if (this.controlValues.disabled) {
      return null;
    }

    return () => this.onIncreaseValue(1);
  }

  render() {
    return (
      <div class="RACSContainer">
        <div class="RACSControls">
          <div tabindex="0" class={this.minusButtonStyle} onClick={this.minusButtonCallback}>
            <svg width="10" height="2" viewBox="0 0 10 2" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1H5H9" stroke-linecap="round" />
            </svg>
          </div>

          <label class="sr-only">
            {this.label}
          </label>

          <input
            class="RACSAmountInput"
            maxlength="3"
            type="number"
            value={String(this.controlValues.itemAmount)}
            onKeyPress={this.onValidateKey}
            onChange={this.onInputChange}
          />

          <div tabindex="0" class="RACSButton RACSButtonWaved" onClick={this.plusButtonCallback}>
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 4.94092H5M9 4.94092H5M5 4.94092V1M5 4.94092V9" stroke-linecap="round" />
            </svg>
          </div>
        </div>

        {this.controlValues.disabled && <div class="RACSAmountWaiting" />}
      </div>
    );
  }
}
